import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackTimeoutPage} from 'features/shared/payment/pages';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/_statuses/timeout',
)({
  component: () => (
    <PaymentCallbackTimeoutPage
      pageId="statement_payment_timeout"
      navigateTo="/home/statements"
    />
  ),
});
